import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5700%3A287
 *
 * @param {SvgIconProps} props - svg props
 */
export const NotesIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M15.5357 1.5C15.4918 1.53878 15.4493 1.57964 15.4086 1.6225L12.675 4.5H8C6.067 4.5 4.5 6.067 4.5 8V16C4.5 17.933 6.067 19.5 8 19.5H16C17.933 19.5 19.5 17.933 19.5 16V12.5L22.5 9.5V16.5C22.5 19.8137 19.8137 22.5 16.5 22.5H7.5C4.18629 22.5 1.5 19.8137 1.5 16.5V7.5C1.5 4.18629 4.18629 1.5 7.5 1.5H15.5357Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M22.018 1.1651L23.7291 2.73328C24.0383 3.0167 24.055 3.49864 23.7661 3.80276L22.6956 4.92957C22.5033 5.13201 22.1825 5.13771 21.9831 4.94222L19.9442 2.94321C19.746 2.74885 19.7441 2.4302 19.9399 2.23344L20.9797 1.1889C21.2634 0.90387 21.7215 0.893371 22.018 1.1651ZM11.0805 11.7783L10.7601 13.368C10.6913 13.7092 10.9836 14.0145 11.3274 13.9608L12.9399 13.7088C13.5616 13.6117 14.1371 13.3215 14.5848 12.8793L21.2135 6.33281C21.4136 6.1352 21.4114 5.81149 21.2087 5.61659L19.1496 3.63729C18.9527 3.44802 18.6404 3.45176 18.448 3.64571L11.891 10.2586C11.4781 10.6751 11.1963 11.2034 11.0805 11.7783Z' fill={color}/>
        </SvgIcon>
    )
}

export default NotesIcon
